import { Show } from "react-admin";

import { Dashboard } from "./dashboard/Dashboard";

export const MissionShow = () => (
	<Show title="Mission dashboard">
		<Dashboard />
	</Show>
);
